import React, { useState, useMemo } from "react";
import { MessageCircle, ArrowRight, Filter } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { resolveImage } from "../lib/api";
import { buildWhatsAppUrl, openWhatsApp } from "../lib/whatsapp";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";

const Products = () => {
  const { content } = useContent();
  const products = content.products || [];
  const whatsapp = content.company?.whatsapp || "";

  const types = useMemo(() => {
    const t = new Set();
    products.forEach((p) => p.type && t.add(p.type));
    return ["Tümü", ...Array.from(t)];
  }, [products]);

  const [filter, setFilter] = useState("Tümü");
  const filtered = filter === "Tümü" ? products : products.filter((p) => p.type === filter);

  return (
    <section id="products" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <span className="inline-block text-xs font-semibold tracking-[0.25em] text-[#b91c1c] uppercase mb-3">— Ürünlerimiz</span>
            <h2 className="text-3xl md:text-4xl font-black text-[#b91c1c] leading-tight">Kümes Hayvanlarımız</h2>
            <p className="text-slate-600 mt-3 max-w-xl">Tüm yarka ve hindi çeşitlerimizi inceleyebilir, WhatsApp üzerinden hızlıca iletişime geçebilir veya teklif talebi oluşturabilirsiniz.</p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <Filter className="w-4 h-4 text-slate-500 mr-1" />
            {types.map((t) => (
              <button key={t} onClick={() => setFilter(t)} className={`px-4 py-2 rounded-full text-xs font-semibold transition-colors border ${filter === t ? "bg-[#b91c1c] text-white border-[#b91c1c]" : "bg-white text-slate-700 border-slate-200 hover:border-[#b91c1c]"}`}>
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {filtered.map((p) => {
            const msg = `Merhaba, ${p.name} hakkında bilgi ve fiyat teklifi almak istiyorum.`;
            return (
              <div key={p.id} className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl border border-slate-100 transition-all duration-300 hover:-translate-y-1">
                <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
                  {p.image && (
                    <img loading="lazy" decoding="async" src={resolveImage(p.image)} alt={p.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                  )}
                  {p.badge && <Badge className="absolute top-3 left-3 bg-[#b91c1c] text-white border-0 font-medium">{p.badge}</Badge>}
                  <div className="absolute top-3 right-3 bg-white/90 backdrop-blur px-2.5 py-1 rounded-full text-[10px] font-semibold text-[#b91c1c] uppercase tracking-wider">{p.type}</div>
                </div>
                <div className="p-5">
                  <h3 className="text-lg font-bold text-[#b91c1c] mb-2">{p.name}</h3>
                  <p className="text-sm text-slate-600 leading-relaxed mb-4 min-h-[60px]">{p.desc}</p>
                  <div className="flex gap-2">
                    <Button asChild size="sm" variant="outline" className="flex-1 border-[#b91c1c]/20 text-[#b91c1c] hover:bg-[#b91c1c] hover:text-white hover:border-[#b91c1c]">
                      <a href="#contact">Detay <ArrowRight className="w-3.5 h-3.5 ml-1" /></a>
                    </Button>
                    <Button asChild size="sm" className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white">
                      <a href={buildWhatsAppUrl(whatsapp, msg)} onClick={(e) => { e.preventDefault(); openWhatsApp(whatsapp, msg); }} target="_blank" rel="noopener noreferrer">
                        <MessageCircle className="w-3.5 h-3.5 mr-1" /> Fiyat Al
                      </a>
                    </Button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Products;
